// extracted by mini-css-extract-plugin
module.exports = {"pt-user-roles":"pt-user-roles-e9d6a0b5b0f98ae4571774a11288acac"};